<!--
  ForwardSidebar — contextual sidebar for the "Forward" cauldron
  (forward-market dashboards: electricity / gas / oil / coal / emissions /
  TB-spreads). One row per commodity dashboard, deep-linked to
  `/reports/forward/<id>`. Rows are sourced from `src/dashboards/
  metadata.js` so adding a new commodity dashboard there extends this
  sidebar automatically.
-->
<template>
  <div class="flex flex-col h-full">
    <nav class="flex-1 overflow-y-auto px-3 py-3" aria-label="Forward markets navigation">
      <div v-if="!collapsed" class="sidebar-section-label">
        {{ t('cauldron.forward.label') }}
      </div>

      <sidebar-menu-item
        v-for="dash in forwardDashboards"
        :key="dash.id"
        :to="dash.route"
        :label="t(dash.title)"
        :icon="dash.icon"
        :collapsed="collapsed"
        active-match="prefix"
        @click="emit('navigate')"
      />
    </nav>
  </div>
</template>

<script setup>
  /* eslint-disable no-undef */
  import SidebarMenuItem from '@/components/navigation/SidebarMenuItem.vue';
  import { forwardDashboards } from '@/features/visualizations/domain/metadata';
  import { useI18n } from 'vue-i18n';

  defineProps({
    collapsed: { type: Boolean, default: false },
  });
  const emit = defineEmits(['navigate']);

  const { t } = useI18n();
</script>
